// assets/js/podcast-player.js
// Player podcast auto-hébergé (Shikwasa) : yarn add shikwasa  (le projet est verrouillé sur Yarn 1, ne pas utiliser npm install)
//
// Dans l'entrée Encore (app.js) :
//   import { initPodcastPlayers } from './js/podcast-player';
//
// ⚠️ Si la page podcasts utilise le rechargement AJAX (recherche/pagination,
// bloc isXmlHttpRequest du PodcastController), rappeler initPodcastPlayers()
// après l'injection du HTML retourné, sinon les nouveaux items n'auront pas
// de player :
//   container.innerHTML = json.html;
//   initPodcastPlayers(container);

import 'shikwasa/dist/style.css';
import { Player } from 'shikwasa';

export function initPodcastPlayers(root = document) {
    root.querySelectorAll('.podcast-player:not([data-player-init])').forEach((el) => {
        // Garde-fou : évite la double initialisation du même élément
        el.dataset.playerInit = '1';

        new Player({
            container: () => el,
            themeColor: '#13568f', // couleur charte podcast (cf. podcasts.css)
            // 'static' : le player reste dans le flux de la page. Le défaut 'auto'
            // le fixe en bas du viewport sur petit écran, et dans le listing
            // podcasts plusieurs players se superposeraient.
            fixed: { type: 'static' },
            audio: {
                title: el.dataset.title,
                cover: el.dataset.cover || null,
                src: el.dataset.src,
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', () => initPodcastPlayers());
